
const Home = ({ width = 18, height = 18 }) => (
	<svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M0.875 8.99986L8.33709 1.53777C8.7032 1.17165 9.2968 1.17165 9.66291 1.53777L17.125 8.99986M2.75 7.12486V15.5624C2.75 16.0801 3.16973 16.4999 3.6875 16.4999H7.125V12.4374C7.125 11.9196 7.54473 11.4999 8.0625 11.4999H9.9375C10.4553 11.4999 10.875 11.9196 10.875 12.4374V16.4999H14.3125C14.8303 16.4999 15.25 16.0801 15.25 15.5624V7.12486M5.875 16.4999H12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);
export default Home;
  